import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {
navigate() {
throw new Error('Method not implemented.');
}

  constructor() { }

  ngOnInit(): void {
  }

}

